import * as React from 'react';
import bindAllOfThis from 'src/utils/BindThisHelper';
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/ProgramRobotGame/scenes/GameIntro';

interface PhaserProgramRobotGameProps {
    onComplete: () => void;
}

interface PhaserProgramRobotGameState {
}

const gameConfig: GameConfig = {
    title: "Program Robot Game",
    version: "0.9.3",
    backgroundColor: "#000000"
};

class PhaserProgramRobotGame extends React.Component<PhaserProgramRobotGameProps, PhaserProgramRobotGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserProgramRobotGameProps) {
        super(props);
        bindAllOfThis(this, PhaserProgramRobotGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete}/>
        </div>);
    }
}

export default PhaserProgramRobotGame;



// WEBPACK FOOTER //
// ./src/games/ProgramRobotGame/Main.tsx